

import Temp from './pages/TempPage'
import ReturnsIndex from './pages/ReturnsPage'
import OcrIndex from './pages/OCRPage'
import Prototype from './pages/PrototypePage'
import SendPushMessagePage from './pages/SendPushMessagePage'



const AppRoutes = [

  {
    path:"/temp",
    element: <Temp />
  },

  {
    path:"",
    element: <ReturnsIndex />
  },
  {
    path:"/returns",
    element: <ReturnsIndex />
  },
  {
    path:"/ocr",
    element: <OcrIndex />
  },
  {
    path:"/prototype",
    element: <Prototype />
  },
  {
    path:"/sendPushMessage",
    element: <SendPushMessagePage />
  }
    
];

export default AppRoutes;
